import React from 'react';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

const TEST_ID = 'play-circle-icon';
export const PlayCircleIcon = ({ width = 48, height = 48, fill = 'white', size }: IconProps) => {
    const iconSize = size ? IconSizes[size] : undefined;

    return (
        <svg
            width={iconSize ?? width}
            height={iconSize ?? height}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={TEST_ID}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM8.59974 7.11608C8.5 7.24931 8.5 7.48795 8.5 7.96524V14.0346C8.5 14.5119 8.5 14.7505 8.59974 14.8837C8.68666 14.9998 8.81971 15.0725 8.96438 15.0828C9.1304 15.0947 9.3311 14.9656 9.7326 14.7075L14.4532 11.6728C14.8016 11.4489 14.9758 11.3369 15.0359 11.1945C15.0885 11.0701 15.0885 10.9297 15.0359 10.8053C14.9758 10.6629 14.8016 10.5509 14.4532 10.327L9.7326 7.2923C9.3311 7.0342 9.1304 6.90515 8.96438 6.91701C8.81971 6.92734 8.68666 6.99998 8.59974 7.11608Z"
                fill={fill}
            />
        </svg>
    );
};
PlayCircleIcon.TEST_ID = TEST_ID;
